import {  homeAddress } from '../../api/home'
const sessionStorage  =  window.sessionStorage

// initial state
const state = {
	isOnline: false,
	token: null,
	user: null,
	isTokenInvalid: false,		
	flag: false,
	address: null,
	shoplist:null,//JSON.parse(sessionStorage.getItem("shoplist")),
	shop:null,//JSON.parse(sessionStorage.getItem("shop")),
	version:window.version
}

// mutations
const mutations = {
	signin(state, payload) {
		state.isOnline = true
		state.user = payload.user
		state.token = payload.token
		state.isTokenInvalid = false
	},
	saveShopList(state, items) {
		// sessionStorage.setItem("shoplist",JSON.stringify(items))
		state.shoplist = items
	},
	saveHomeAddress(state, data) {
		state.address = data
	},
	saveShop(state, items) {
		// sessionStorage.setItem("shop",JSON.stringify(items))
		state.shop = items
	},
	clearShop(state, items) {
		// sessionStorage.setItem("shop","{}")
		state.shop = null
	},
	signout(state) {
		this.commit('clearUser')
		this.commit('clearToken')
	},
	kickout(state) {
		this.commit('clearUser')
		this.commit('clearToken')
		state.isTokenInvalid = true
	},
	saveUser(state, payload) {
		state.user = payload.user
	},
	saveToken(state, payload) {
		state.isOnline = true
		state.isTokenInvalid = false
		state.token = payload.token
	},
	clearUser(state) {
		state.user = null
	},
	clearToken(state) {
		state.isOnline = false
		state.token = null
	},
	changeFlag(state, value) {
		state.flag = value;
	}
}

// actions 
function getQueryVariable(variable){
	let query = window.location.hash.substring(1);
	let vars = query.split("&");
	for (let i=0;i<vars.length;i++) {
		let pair = vars[i].split("=");
		if(pair[0] == variable){return pair[1];}
	}
	return(false);
}
const actions = {
	fetchHomeAddress({ commit, state }, params) {
		return new Promise((resolve, reject) => {
				homeAddress(params.lng, params.lat, params.type ).then(
					response => {
						if (response && response.error_code ==0) {
							commit('saveHomeAddress', response.result)
							commit('saveShopList',response.shoplist)
							if(Array.isArray(response.shoplist) && response.shoplist.length>0){
								let urlShopId =  getQueryVariable('shopId')
								if(urlShopId){
									let index = response.shoplist.findIndex(item=>item.id ==urlShopId)
									if(index > -1 && urlShopId != (state.shop|| {} ).id ){
										commit('saveShop',response.shoplist[index] || {})
										window.location.replace(window.location.href)
									}
								}else if(state.shop){
									let index = response.shoplist.findIndex(item=>item.id ==state.shop.id)
									if(index == -1){
										commit('saveShop',response.shoplist[0] || {})
										window.location.replace(window.location.href)
									}
								}else{
									commit('saveShop',response.shoplist[0] || {})
								}
							}
						}
						resolve(response)
					},
					error => {
						reject(error)
					}
				)
			// }
		})
	}
}

export default {
	state,
	mutations,
	actions
}



// WEBPACK FOOTER //
// ./src/store/modules/auth.js